import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    perfilar: {
        resultado_asesoria: null,
        tipo_cliente: null
    },
    preaprobado: {
        documentos: [],
        radicacionForm: {
            financiera: null,
            plazo: null,
            plan: null,
            nombre_asesor: null,
            telefono: null,
            correo_asesor: null,
            fecha_envio: null,
        }
    },
    aprobado: {
        fecha_firmas: null,
        documentoCredito: null,
        sitio_peritaje: null,
        encargado: null,
        fecha: null,
        hora: null
    },
    desembolso: {
        resultado: null,
        fecha: null,
        comision: 0
    },
};

const mutations = {
    updateField,
    updateSteps: (state, payload) =>{
        var perfilar = Object.keys(payload.perfilar).length;
        if (perfilar > 0) {
            state.perfilar = payload.perfilar;
        }
        var preaprobado = Object.keys(payload.preaprobado).length;
        if (preaprobado > 0) {
            state.preaprobado = payload.preaprobado;
        }
        var aprobado = Object.keys(payload.aprobado).length;
        if (aprobado > 0) {
            state.aprobado = {
                ...state.aprobado,
                ...payload.aprobado
            };
        }
        var desembolso = Object.keys(payload.desembolso).length;
        if (desembolso > 0) {
            state.desembolso = payload.desembolso;
        }
    }
};

const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
